import Quill from 'quill';
import React, { useCallback, useEffect, useRef } from 'react';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { useResolve } from '../../Container';
import { UIField, UIFieldProps } from '../../canvas/entities/UIField';
import { useComponentObserver } from '../../canvas/visualization/ComponentObserver';
import { AtsertAnnotationWidget, useAtsertWidgetBridge } from '../annotations/AnnotationAtsertWidget';
import { submitMentions } from '../annotations/MentionCommands';
import { QuillInput } from '../mentions/QuillInput';
import { IndexCard } from './IndexCard';

export const IndexCardContentFieldEditor = ({ active, field }: UIFieldProps) => {

    const objects = useResolve(ObjectManager);
    const dispatch = useResolve(CommandDispatcher);
    const object = field.owner.cast(IndexCard);
    useComponentObserver(object);

    const onChange = useCallback((nextValue: string) => {
        objects.update(u => {
            u.rolling(UIField.key(field));
            object.content = nextValue;
        });
    }, [field]);

    const onCommit = useCallback(() => {
        objects.update(u => u.noop());
        dispatch(submitMentions, [[object.id]]);
    }, []);

    const atsert = useAtsertWidgetBridge({ name: 'atsertAnnotation', ui: AtsertAnnotationWidget }, object);
    const instanceRef = useRef<Quill>(null);

    useEffect(() => {
        if (active) {
            instanceRef.current?.focus();
        }
    }, [instanceRef.current, active]);

    return <QuillInput key={UIField.key(field)} {...{
        instanceRef,
        initialValue: object.content,
        onChange,
        onCommit,
        atsert,
        formatting: ['mention', 'bold', 'italic', 'list'],
        textSettings: object.layout.content.settings,
    }} />;
};

export const IndexCardContentField = (owner: IndexCard): UIField => ({
    ui: IndexCardContentFieldEditor,
    name: 'content',
    bounds: owner.layout.content.bounds,
    owner,
});
